module.exports = global["Swiper"] = require("-!/srv/projects/metalloiskateli.com.ua/node_modules/babel-loader/lib/index.js??ref--0-0!./swiper.js");